/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/CompensationMasterData/PayGrades.tsx
 * PURPOSE: Pay Grade management page — thin wrapper mounting the generic
 *          MasterDataCrudPage with payGradeSchema (BR-COMP-002 §8 R1).
 * SDLC FRAMEWORK VERSION: 6.3.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * DATE: 2026-07-12
 * COMPLIANCE: SDLC 6.3.1 + BR-PLAT-001-MASTER-DATA-CRUD-IMPORT-EXPORT-STANDARD
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * @business-context
 * - Domain: Vietnamese Compensation Master Data (thang bảng lương)
 * - Impact: Pay grades can now be pre-created by Tenant Admins instead of
 *   silently resolving to NULL at compensation-assignment time (BR-2.5 gap)
 * - Stakeholders: CFO / HR Director (TENANT_ADMIN)
 *
 * @technical-architecture
 * - Layer: Frontend Presentation Layer
 * - Pattern: Config-Driven UI
 * - Dependencies: frontend/src/components/master-data/MasterDataCrudPage.tsx
 *
 * @cross-references
 * - Schema: frontend/src/pages/CompensationMasterData/payGradeSchema.ts
 * - Route: frontend/src/App.tsx (/tenant-admin/compensation/pay-grades)
 * - BR: docs/01-planning/01-requirements/08-compensation/BR-COMP-002-job-family-paygrade-management.md
 */

import React from 'react';
import { MasterDataCrudPage } from '@/components/master-data/MasterDataCrudPage';
import { payGradeSchema } from './payGradeSchema';

export const PayGrades: React.FC = () => {
  return <MasterDataCrudPage schema={payGradeSchema} />;
};

export default PayGrades;
